import request from '@/utils/request'

// ==================== 视频标签相关 ====================

/**
 * 获取视频时间标签列表
 * @param {Number} sectionId 小节ID
 */
export function getVideoMarkers(sectionId) {
  return request({
    url: `/amc/video-marker/list/${sectionId}`,
    method: 'get'
  })
}

/**
 * 批量保存视频时间标签
 * @param {Object} data {sectionId, markers: [{timeSeconds, label, sort}]}
 */
export function saveVideoMarkers(data) {
  return request({
    url: '/amc/video-marker/batch-save',
    method: 'post',
    data
  })
}

/**
 * 保存单个视频标签
 * @param {Object} data {sectionId, timeSeconds, label, sort}
 */
export function addVideoMarker(data) {
  return request({
    url: '/amc/video-marker',
    method: 'post',
    data
  })
}

/**
 * 删除视频标签
 * @param {Number} id 标签ID
 */
export function deleteVideoMarker(id) {
  return request({
    url: `/amc/video-marker/${id}`,
    method: 'delete'
  })
}

// ==================== 视频题目关联 ====================

/**
 * 获取小节关联的视频题目
 * @param {Number} sectionId 小节ID
 */
export function getVideoQuestions(sectionId) {
  return request({
    url: `/amc/video-question/list/${sectionId}`,
    method: 'get'
  })
}

/**
 * 添加视频题目
 * @param {Object} data {sectionId, questionId, popTimeSeconds, durationSeconds}
 */
export function addVideoQuestion(data) {
  return request({
    url: '/amc/video-question',
    method: 'post',
    data
  })
}

/**
 * 批量添加视频题目
 * @param {Object} data {sectionId, questions: [{questionId, popTimeSeconds, durationSeconds}]}
 */
export function batchAddVideoQuestions(data) {
  return request({
    url: '/amc/video-question/batch',
    method: 'post',
    data
  })
}

/**
 * 删除视频题目
 * @param {Number} id 关联ID
 */
export function deleteVideoQuestion(id) {
  return request({
    url: `/amc/video-question/${id}`,
    method: 'delete'
  })
}

// ==================== 学生视频答题 ====================

/**
 * 提交视频答题
 * @param {Object} data {sectionId, questionId, userAnswer, answerTimeCost, handwritingImageUrl}
 */
export function submitVideoAnswer(data) {
  return request({
    url: '/amc/video-answer/submit',
    method: 'post',
    data
  })
}

/**
 * 获取学生的视频答题记录
 * @param {Number} sectionId 小节ID
 */
export function getStudentVideoAnswers(sectionId) {
  return request({
    url: `/amc/video-answer/my-answers/${sectionId}`,
    method: 'get'
  })
}

/**
 * 上传手写答题图片
 * @param {FormData} formData 包含图片文件
 */
export function uploadHandwriting(formData) {
  return request({
    url: '/amc/video-answer/upload-handwriting',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

/**
 * 教师查看学生视频答题记录
 * @param {Number} sectionId 小节ID
 * @param {Number} studentId 学生ID（可选）
 * @param {Number} questionId 题目ID（可选）
 */
export function getStudentVideoAnswersByTeacher(sectionId, studentId, questionId) {
  return request({
    url: '/amc/video-answer/teacher/student-answers',
    method: 'get',
    params: { sectionId, studentId, questionId }
  })
}

/**
 * 教师查看视频答题统计
 * @param {Number} sectionId 小节ID
 * @param {Number} classId 班级ID（可选，用于筛选特定班级）
 */
export function getVideoAnswerStatistics(sectionId, classId) {
  return request({
    url: `/amc/video-answer/teacher/statistics/${sectionId}`,
    method: 'get',
    params: { classId }
  })
}

/**
 * 学生查看自己的答题记录
 * @param {Number} courseId 课程ID（可选）
 * @param {Number} sectionId 小节ID（可选）
 */
export function getMyVideoAnswers(courseId, sectionId) {
  return request({
    url: '/amc/video-answer/my-records',
    method: 'get',
    params: { courseId, sectionId }
  })
}

/**
 * 学生查看自己的答题统计
 * @param {Number} courseId 课程ID（可选）
 */
export function getMyVideoStatistics(courseId) {
  return request({
    url: '/amc/video-answer/my-statistics',
    method: 'get',
    params: { courseId }
  })
}
